import {
  RESET_PUBLIC_GROUPS,
  RESET_USER_DETAILS,
  RESET_USER_GAME,
  SAVE_PUBLIC_GROUPS,
  SAVE_USER_DETAILS,
  SAVE_USER_GAME,
} from "../types";

const INITIAL_STATE = {
  profile: {
    username: null,
    email: null,
    id: null,
  },
  games: null,
  groups: null,
  cards: null,
};

const userReducer = (state = INITIAL_STATE, { type, payload }) => {
  switch (type) {
    case SAVE_USER_DETAILS:
      return {
        ...state,
        profile: {
          username: payload.username,
          email: payload.email,
          id: payload.id,
        },
        games: {
          list: [],
          showViewMore: false,
          pageNumber: 1,
          pageSize: 10,
        },
        groups: {
          list: [],
          showViewMore: false,
          pageNumber: 1,
          pageSize: 10,
        },
        cards: {},
      };

    case RESET_USER_DETAILS:
      return {
        ...INITIAL_STATE,
      };

    case SAVE_USER_GAME:
      return {
        ...state,
        games: {
          pageSize: 10,
          ...payload,
        },
      };

    case RESET_USER_GAME:
      return {
        ...state,
        games: INITIAL_STATE.games,
      };

    case SAVE_PUBLIC_GROUPS:
      return {
        ...state,
        groups: {
          pageSize: 10,
          ...payload,
        },
      };

    case RESET_PUBLIC_GROUPS:
      return {
        ...state,
        groups: INITIAL_STATE.groups,
      };

    case "SAVE_USER_CARD":
      return {
        ...state,
        cards: {
          ...(state.cards || {}),
          [payload.gameId]: payload.cardData,
        },
      };

    case "RESET_USER_CARDS":
      return {
        ...state,
        cards: INITIAL_STATE.cards,
      };

    default:
      return state;
  }
};

export default userReducer;
